/**
 * Documents Phase 3: document expiry badge.
 * Green >21 days out, amber ≤21, red ≤7 or already expired (no grace period).
 * Renders nothing when the document carries no expiry date.
 */

import { daysUntil, expiryTone, fmtDate } from '../lib/date.js';

const TONE_CLASS = {
  green: 'pill-success',
  amber: 'pill-warn',
  red: 'pill-danger',
} as const;

export function ExpiryBadge({ expiryDate }: { expiryDate: string | null }) {
  const tone = expiryTone(expiryDate);
  if (!expiryDate || !tone) return null;
  const days = daysUntil(expiryDate);
  const ago = -days;
  const label = days < 0
    ? `Expired ${ago} ${ago === 1 ? 'day' : 'days'} ago · ${fmtDate(expiryDate)}`
    : days <= 21
      ? `${days}d left · ${fmtDate(expiryDate)}`
      : fmtDate(expiryDate);
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-md border text-xs font-medium ${TONE_CLASS[tone]}`}>
      {label}
    </span>
  );
}
